import { isNil } from 'lodash-es';
import type { AxiosInstance } from '@aviata/platform-client';

import { getDeviceId } from '../amplitude';

/**
 * Amplitude initialized after pfm init, so amplitude device id doesn't get set in pfm config
 * @param client
 */
export function withAmplitudeDeviceId(client: AxiosInstance) {
  client.interceptors.request.use(
    request => {
      const amplitudeDeviceId = getDeviceId();
      if (!isNil(amplitudeDeviceId)) {
        request.headers['x-amplitude-device-id'] = amplitudeDeviceId;
      }
      return request;
    },
    null,
    { synchronous: true },
  );
}
